module.exports = __webpack_public_path__ + "static/img/ball4v2.8199b9ff.png";